'use client'
/**
 * Custom hook to get the current user's role and information.
 */
import { type MemberResp, type MemberRole } from 'shared/api/clients'
import { useAuth } from 'shared/context/AuthContext'
import { useCurrentClient } from 'shared/context/ClientContext'
import { useQueryMember } from '../api'

const useCurrentMember = (): {
  role: MemberRole
  isLoading: boolean
  member?: MemberResp
} => {
  const { currentUser } = useAuth()
  const { currentClient } = useCurrentClient()
  const { data: member, isLoading } = useQueryMember(currentClient.id, currentUser?.id)

  return {
    role: member?.role ?? 'viewer',
    member,
    isLoading
  }
}

export default useCurrentMember
